import { Loader2 } from 'lucide-react';
import styles from './TicketListLoading.module.css';

/**
 * Loading affordance for the ticket list views (Inbox, Archive, Drafts).
 *
 * Spinner + label rather than skeleton cards is intentional: skeletons
 * would mean matching the KCard shape and props — a lot of code for a
 * 1-2 second window. If we ever pre-render skeleton cards we can swap
 * the internals; the call sites don't need to change.
 */
export function TicketListLoading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <Loader2 size={16} className={styles.spinner} aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
